import React from 'react';
import '../styles/spinner.css'; // You need to create this CSS file for styling the spinner

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner" />
  </div>
);

export default Spinner;
